import React, { useEffect, useRef } from "react";
import { updateVideoStream } from "lib/liveStreamHelpers";
import { ProduceStream } from "types";
import BaseAvatar from "components/BaseAvatar";
import BaseIcon from "components/BaseIcon";
import NetworkQualityBadge from "components/NetworkQualityBadge";
import "./style.scss";

interface Props {
  item: ProduceStream;
  className?: string;
  forceMute?: boolean;
  mirrorReflection?: boolean;
  onClick: () => void;
  setPlayer?: React.Dispatch<React.SetStateAction<HTMLVideoElement | null>>;
  hide?: boolean;
  contain?: boolean;
}

export default function ProduceStreamItem({ item, className, forceMute, mirrorReflection, hide, contain, onClick, setPlayer }: Props) {
  const player = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    return updateVideoStream(player.current, item.stream);
  }, [item.stream, item.hasVideo, item.hasAudio, player]);

  useEffect(() => {
    setPlayer && setPlayer(player.current);
  }, [player, setPlayer]);

  const cls = ["produce-stream-item d-center pointer"];
  if (!item.hasVideo) cls.push("__disabled-video");
  if (hide) cls.push("hidden");
  if (className) cls.push(className);
  if (contain) cls.push("__contain");
  if (mirrorReflection) cls.push("__mirror-reflection");
  if (item.isSpeaking) cls.push("__speaking");

  return (
    <div className={cls.join(" ")} onClick={onClick}>
      <video className="produce-stream-item__video" ref={player} muted={forceMute} playsInline autoPlay />
      {!item.hasVideo && <BaseAvatar size={50} user={item.user.user} />}
      {item.user.screenName && (
        <div className="produce-stream-item__screen-name pa-1 truncate-ellipsis">
          {item.user.screenName}
          {item.user.user === null && <span className="produce-stream-item__guest-badge"> (Guest)</span>}
        </div>
      )}
      {item.quality !== undefined && (
        <NetworkQualityBadge quality={item.quality} className="produce-stream-item__network-badge" />
      )}
      {item.videoAutoPaused && (
        <div className="produce-stream-item__video-paused" title="Video paused due to network">
          <BaseIcon size={18}>videocam_off</BaseIcon>
        </div>
      )}
      {!item.hasAudio && (
        <div className="produce-stream-item__muted">
          <BaseIcon className="produce-stream-item__muted-icon" size={18}>
            mic_off
          </BaseIcon>
        </div>
      )}
    </div>
  );
}
